import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Gift, ShieldAlert, LogOut } from 'lucide-react';
import { logout, getCurrentStaff, isManager } from '../services/api';

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const staff = getCurrentStaff();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-3 px-4 py-3 rounded-lg transition ${
      isActive
        ? 'bg-buggy-blue text-white'
        : 'text-buggy-gray hover:bg-gray-100 hover:text-buggy-dark'
    }`;

  return (
    <div className="w-64 bg-white h-screen flex flex-col border-r">
      {/* Logo */}
      <div className="p-6 border-b">
        <h1 className="text-xl font-bold text-buggy-dark">InsiderPass</h1>
        <p className="text-sm text-buggy-gray">Admin Portal</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2">
        <NavLink to="/dashboard" className={navLinkClass}>
          <LayoutDashboard className="w-5 h-5" />
          Validate Code
        </NavLink>

        <NavLink to="/members" className={navLinkClass}>
          <Users className="w-5 h-5" />
          Members
        </NavLink>

        {isManager() && (
          <NavLink to="/redemptions" className={navLinkClass}>
            <Gift className="w-5 h-5" />
            All Redemptions
          </NavLink>
        )}

        {isManager() && (
          <NavLink to="/violations" className={navLinkClass}>
            <ShieldAlert className="w-5 h-5" />
            Violation Types
          </NavLink>
        )}
      </nav>

      {/* User Info & Logout */}
      <div className="p-4 border-t">
        {staff && (
          <div className="mb-3 px-4">
            <p className="font-medium text-buggy-dark text-sm">
              {staff.firstName} {staff.lastName}
            </p>
            <p className="text-xs text-buggy-gray capitalize">{staff.role}</p>
          </div>
        )}
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition w-full"
        >
          <LogOut className="w-5 h-5" />
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
